module.exports = __webpack_public_path__ + "prod-assets/vid1-2af338.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/vid1.mp4
// module id = 25
// module chunks = 0